module.exports = __webpack_public_path__ + "static/media/ZTIC.aa307fda.pdf";